import { AxiosResponse } from 'axios';

import { PAYMENT_URL } from '../../config';
import { post } from '../api';
import { PaymentDTO } from './payment.d';

export const getStripePaymentSecretKey = async (
  data: PaymentDTO
): Promise<AxiosResponse<{ clientSecret: string; confirmationId: string }>> =>
  await post('/payment/stripe/pay-for-project', data, PAYMENT_URL);
